import React from "react";

const EmptyList = ({ title, description }) => {
  return (
    <div className="max-w-7xl mx-auto my-5">
      <div className="flex items-center justify-center">
        <img
          style={{ width: "100%", height: "300px", objectFit: "contain" }}
          src="/assets/images/not-found.png"
          alt="Not-found"
        />
      </div>
      <h4 className="text-center text-2xl mt-10 mb-5 text-gray-500 italic">
        {title}
      </h4>
      {description && <p className="text-center text-sm text-gray-500 italic">{description}</p>}
    </div>
  );
};

export default EmptyList;
